import BaseButton from 'core/buttons/base-button';
import dynamic from 'next/dynamic';
import getRoundedNumber from 'utils/get-rounded-number';
import PriceTagItem from 'components/landing/tables/components/price-tag/price-tag-item';
import PropTypes from 'prop-types';
import RangeIndicator from 'components/landing/tables/components/slider-indicator/slider-indicator';
import styles from 'styles/SmallItemBase.module.scss';
import useRichTranslation from 'hooks/useRichTranslation';
import variables from 'styles/variables.module.scss';

const CarIconMapper = dynamic(() => import('components/icons/landing/car-brand-icons/mapper'));

const QuotationByCarCategoryItemSmall = ({
    familyName,
    carBrand,
    carName,
    colorSchema,
    coveredItems,
    price,
    totalCoveredItems
}) => {
    const PRICE = getRoundedNumber(price);
    const t = useRichTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div style={{ backgroundColor: colorSchema }}>
                    <CarIconMapper input={carBrand} color={variables.whiteColor} height={22} />
                    <p>{carName}</p>
                </div>
            </div>
            <div className={styles.content}>
                <div>
                    <PriceTagItem
                        tagType="price-label"
                        value={PRICE}
                        fontSize={20}
                    />
                    <p className={styles.family_name}>{familyName}</p>
                </div>
                <div style={{ backgroundColor: variables.grayColor }}>
                    <div className={styles.range__wrapper}>
                        <p className={styles.label}>
                            <strong>{coveredItems}</strong>
                            {'\t'}
                            {t('table.quotation-by-car-category.of')}
                            {'\t'}
                            <strong>{totalCoveredItems}</strong>
                            {'\t'}
                            {t('table.quotation-by-car-category.items-covered')}
                        </p>
                        <RangeIndicator
                            range={totalCoveredItems}
                            width={140}
                            value={coveredItems}
                            colorSchema={colorSchema}
                        />
                    </div>
                    <BaseButton
                        href={t('quoter')}
                        divClass={styles.button__wrapper}
                        buttonClass={styles.button}
                        label={t('table.quotation-by-car-category.more-info')}
                    />
                </div>
            </div>
        </div>
    );
};

QuotationByCarCategoryItemSmall.propTypes = {
    familyName: PropTypes.string,
    carBrand: PropTypes.string,
    carName: PropTypes.string,
    colorSchema: PropTypes.string,
    coveredItems: PropTypes.number,
    price: PropTypes.number,
    totalCoveredItems: PropTypes.number
};

export default QuotationByCarCategoryItemSmall;
